import React from 'react';
import { Paper, Typography, Box, CircularProgress } from '@mui/material';
import { useBuild } from '../contexts/BuildContext';
import ResultsList from '../components/ResultsList';


const ResultsColumn = () => {

  const { searchResults, isLoading } = useBuild();
  const hasQueryResults = searchResults && searchResults.result;

  // Render appropriate content based on state
  const renderContent = () => {
    // Show loading indicator while fetching
    if (isLoading) {
      return (
        <Box sx={{ 
          display: 'flex', 
          flexDirection: 'column',
          alignItems: 'center', 
          justifyContent: 'center',
          height: '100%',
          gap: 2
        }}>
          <CircularProgress />
          <Typography variant="body2" color="text.secondary">
            Fetching results...
          </Typography>
        </Box>
      );
    }

    // Show empty state when no results yet
    if (!hasQueryResults) {
      return (
        <Typography variant="body2" color="text.secondary">
          No query results yet. Execute a query to see results here.
        </Typography>
      );
    }

    const hits = searchResults.result.hits || [];
    
    // Show no results message when query returned empty
    if (hits.length === 0) {
      return (
        <Typography variant="body2" color="text.secondary">
          No results found for the current query.
        </Typography>
      );
    }

    // Render all hits with appropriate card components
    return <ResultsList hits={hits} />;
  };

  return (
    <Paper elevation={2} sx={{ p: 2, height: '100%', display: 'flex', flexDirection: 'column' }}>
      <Typography variant="h6" gutterBottom>
        Results
      </Typography>
      <Box sx={{ mt: 2, flex: 1, overflow: 'auto' }}>
        {renderContent()}
      </Box>
    </Paper>
  );
};

export default ResultsColumn;
